"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DeliveryOptionsDialog = void 0;
var _mui = require("@ori-ui/mui");
var _environment = require("@ori/environment");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../../constants");
var _swrConfig = require("../../constants/swrConfig");
var _SearchConfigurationProvider = require("../../containers/SearchConfigurationProvider");
var _contexts = require("../../contexts");
var _addressFormContext = require("../../contexts/addressFormContext");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _Loading = require("../Loading");
var _DeliveryOptionsDialogContent = require("./DeliveryOptionsDialogContent");
var _styles = require("./styles");
var _usePickupPointsDialog = require("./usePickupPointsDialog");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const AddressForm = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require('@ori/address-form')))).DeliveryAddressForm
}));
const ConfirmDeleteAddressDialog = /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require('../addresses/ConfirmDeleteAddressDialog'))));
const FindPickupPoints = /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require('../FindPickupPoints/FindPickupPoints'))));
const SelectPickupPointDialog = /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require('../SelectPickupPointDialog/SelectPickupPointDialog'))));
const DeliveryOptionsDialog = ({
  isAddHomeDeliveryAddressAllowed,
  isDisplayingAddresses,
  isMapEnabled,
  isPickUpAvailable,
  lastDeliveryItemFee,
  lastDeliveryItemMethod,
  setIsDisplayingAddresses,
  isFlatSelection,
  isDeliveryOptionsLoaded,
  onDeliveryItemActivation,
  selectedItem,
  toggleDeliveryOptionsDialog,
  ...props
}) => {
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();

  // Check if the map list merge feature toggle is enabled
  const {
    data: mapListMerge
  } = (0, _staticApiClientReact.useGetTenantFeatureToggle)(tenant, _constants.MapListMergeFeatureToggle, {
    swr: _swrConfig.basicSwrOptions
  });
  const {
    isFindPickupPointsOpen,
    togglePickupPointsDialog
  } = (0, _usePickupPointsDialog.usePickupPointsDialog)();
  const {
    addressFormProps,
    addressFormTitle,
    confirmDeleteAddressDialogProps,
    isAddressFormOpen,
    isConfirmDeleteAddressDialogOpen
  } = (0, _addressFormContext.useAddressForm)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
      open: true,
      disableEnforceFocus: isFindPickupPointsOpen,
      header: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "h4",
        children: formatMessage('deliveryOptions')
      }),
      maxWidth: "700px",
      onClose: toggleDeliveryOptionsDialog,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeliveryOptionsDialogContent.DeliveryOptionsDialogContent, {
        ...props,
        selectedItem: selectedItem,
        isDisplayingAddresses: isDisplayingAddresses,
        setIsDisplayingAddresses: setIsDisplayingAddresses,
        isFlatSelection: isFlatSelection,
        isDeliveryOptionsLoaded: isDeliveryOptionsLoaded,
        isPickUpAvailable: isPickUpAvailable,
        isAddHomeDeliveryAddressAllowed: isAddHomeDeliveryAddressAllowed,
        newDeliveryProps: {
          isAddHomeDeliveryAddressAllowed,
          isPickUpAvailable,
          lastDeliveryItemFee,
          lastDeliveryItemMethod,
          togglePickupPointsDialog
        },
        historyToggleProps: {
          ...getTestIdProps(_models.TestId.DeliveryToggleHistoryAddress),
          checked: isDisplayingAddresses,
          firstText: formatMessage('history'),
          secondText: formatMessage('addresses'),
          onChange: e => setIsDisplayingAddresses(e.currentTarget.checked)
        },
        onDeliveryItemActivation: onDeliveryItemActivation
      })
    }), isDeliveryOptionsLoaded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.DialogLoadingOverlay, {
        id: _models.TestId.DialogLoadingOverlayFindPickupPoints
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchConfigurationProvider.SearchConfigurationProvider, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.PickupPointsProvider, {
          enabled: isFindPickupPointsOpen,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.MapProvider, {
            deliveryChannelId: selectedItem?.deliveryChannelId,
            togglePickupPointsDialog: togglePickupPointsDialog,
            onDeliveryItemActivation: onDeliveryItemActivation,
            children: !!mapListMerge?.isEnabled || isFlatSelection ? /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectPickupPointDialog, {
              open: isFindPickupPointsOpen
            }) : isFindPickupPointsOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(FindPickupPoints, {
              isMapEnabled: isMapEnabled,
              togglePickupPointsDialog: togglePickupPointsDialog,
              onDeliveryItemActivation: onDeliveryItemActivation
            }) : null
          })
        })
      })
    }) : null, isAddressFormOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AddressFormWrapper, {
      open: true,
      header: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AddressFormTitle, {
        variant: "h4",
        children: addressFormTitle
      }),
      maxWidth: "700px"
      // eslint-disable-next-line react/jsx-handler-names -- disable pointless rule
      ,

      onClose: addressFormProps.configForm.onCloseDialog,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
        fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.DialogLoadingOverlay, {
          id: _models.TestId.DialogLoadingOverlayAddressForm
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(AddressForm, {
          ...addressFormProps
        })
      })
    }) : null, isConfirmDeleteAddressDialogOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.DialogLoadingOverlay, {
        id: _models.TestId.DialogLoadingOverlayConfirmDeleteAddress
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ConfirmDeleteAddressDialog, {
        ...confirmDeleteAddressDialogProps
      })
    }) : null]
  });
};
exports.DeliveryOptionsDialog = DeliveryOptionsDialog;
var _default = exports.default = DeliveryOptionsDialog;